import { useEffect, useRef, useState } from "react";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import templateServices from "./templateServices";
import { CommonUtilities } from "commonUtils";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import TemplateOption from "components/Common/TemplateOption";

export default function TemplateCreate(param: any) {

    let [search, setSearch] = useState("");
    let [ViewCode, setViewCode] = useState("");
    let [rows, setRows] = useState<any[][]>([]);
    let [FileOrder, setFileOrder] = useState('');
    let [allData, setAllData] = useState<any>([]);
    let [uploadJob, setuploadJob] = useState(false);
    let [ViewName, setViewNamee] = useState<any>([]);
    let [kontactCode, setKontactCode] = useState("");
    let [fileHeader, setfileHeader] = useState<any>([]);
    let [conditionList, setConditionList] = useState("");
    let [tableColumn, setTableColumn] = useState<any>([]);
    let [conditionValue, setConditionValue] = useState("");
    let fileInputRef = useRef<HTMLInputElement | null>(null);
    let [conditionHeader, setConditionHeader] = useState("");
    let [ClientDSPList, setClientDSPList] = useState<any>([]);
    let [korrectMapping, setkorrectMapping] = useState<any>([]);
    let [fileUploaded, setfileUploaded] = useState<File | null>(null);

    const tablesListing = [
        { tableSchema: "dataload", tableName: "ArtistContracts", kontactCode: "MetaDataMappingRawData" },
        { tableSchema: "dataload", tableName: "ArtistPayees", kontactCode: "MetaDataMappingRawData" },
        { tableSchema: "dataload", tableName: "ContractLinks", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "ContractUpload", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "Mappings_AnalysisCodes", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "Mappings_Audits", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "Mappings_Catalogues", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "Mappings_ClassLists", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "Mappings_Formats", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "Mappings_InvoiceHeader", kontactCode: "Invoice" },
        { tableSchema: "dataload", tableName: "Mappings_Territory", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "Mechanicals_All_Links", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "Mechanicals_Contracts", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "Mechanicals_TrackSplits", kontactCode: "MetaDataMapping" },
        { tableSchema: "dataload", tableName: "TempTableCUE", kontactCode: "CUE" },
        { tableSchema: "dataload", tableName: "TransactionsLicense", kontactCode: "MetaDataMappingRawData" },
        { tableSchema: "dataload", tableName: "TransactionsPublisher", kontactCode: "MetaDataMappingRawData" },
        { tableSchema: "Publishing", tableName: "TempTableSong", kontactCode: "SongMaster" },
        { tableSchema: "dataload", tableName: "Matching_Invoices", kontactCode: "MetaDataMapping" },
        { tableSchema: "dbo", tableName: "impHolStream", kontactCode: "" },
        { tableSchema: "dbo", tableName: "impholstream_pub", kontactCode: "" },
        { tableSchema: "dbo", tableName: "MetaDataGenericCompilations", kontactCode: "MetaDataMapping" },
        { tableSchema: "dbo", tableName: "MetaDataGenericTracks", kontactCode: "MetaDataMapping" },
        { tableSchema: "dbo", tableName: "MetaDataGenericV1", kontactCode: "MetaDataMapping" },
    ];

    const conditionType = [
        { conditionType: "Numeric" },
        { conditionType: "EscapeSpecificCharacter" },
    ]

    useEffect(() => {

        templateServices.getDSPList().then((response: any) => {
            ClientDSPList = response
            setClientDSPList(response);
            //console.log(ClientDSPList);
        })
    }, []);

    const upLoadFile = (e: any) => {
        const file = e.target.files?.[0] ?? null;
        fileUploaded = file
        setfileUploaded(fileUploaded);
        console.log(e)
        uploadJob = true;
        setuploadJob(uploadJob)
    }

    const onStateUpload = (e: any) => {
        console.log(e)
        FileOrder = e
        setFileOrder(FileOrder)
        uploadJob = false;
        setuploadJob(uploadJob);
        handleFileChange(fileUploaded)
    }

    const handleFileChange = (e: any) => {
        korrectMapping = []
        setkorrectMapping(korrectMapping)
        fileHeader = []
        setfileHeader(fileHeader)

        const file = e;
        if (!file) return;

        const fileType = file.name.split('.').pop().toLowerCase();

        if (fileType === "csv") {
            Papa.parse(file, {
                complete: (results: any) => {
                    const startIndex =
                        FileOrder === "headerMapping" || FileOrder === "headerMappingData" ? 2 : 1;
                    const dataRows = results.data.slice(startIndex);
                    setAllData(dataRows);

                    const header = results.data[0] || [];
                    setfileHeader(header);
                    if (FileOrder === "headerMapping" || FileOrder === "headerMappingData") {
                        const mapping = results.data[1] || [];
                        setkorrectMapping(mapping);
                    }
                },
                header: false,
            });
        } else if (fileType === "xls" || fileType === "xlsx") {
            // Handle Excel
            const reader = new FileReader();
            reader.onload = (evt) => {

                const result = evt.target?.result;
                if (result && result instanceof ArrayBuffer) {

                    const data = new Uint8Array(result);
                    const workbook = XLSX.read(data, { type: "array" });
                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                    console.log(jsonData)

                    if (FileOrder === "headerOnly") {
                        const header = jsonData[0] || [];
                        fileHeader = header;
                        setfileHeader(header);
                    }

                    if (FileOrder === "headerMapping") {
                        const header = jsonData[0] || [];
                        const mapping = jsonData[1] || [];
                        fileHeader = header;
                        korrectMapping = mapping;
                        setfileHeader(header);
                        setkorrectMapping(mapping);
                    }

                    if (FileOrder === "headerMappingData") {
                        const header = jsonData[0] || [];
                        const mapping = jsonData[1] || [];
                        fileHeader = header;
                        korrectMapping = mapping;
                        setfileHeader(header);
                        setkorrectMapping(mapping);
                    }

                    if (FileOrder === "headerData") {
                        const header = jsonData[0] || [];
                        fileHeader = header;
                        setfileHeader(header);
                    }

                    const totalRows = XLSX.utils.decode_range(worksheet['!ref'] || '').e.r + 1;
                    const startIndex = FileOrder === "headerMapping" || FileOrder === "headerMappingData" ? 2 : 1;
                    const chunkSize = 1000; // rows per chunk

                    for (let i = startIndex; i < totalRows; i += chunkSize) {
                        const end = Math.min(i + chunkSize - 1, totalRows - 1);
                        const range = XLSX.utils.encode_range({ s: { r: i, c: 0 }, e: { r: end, c: worksheet['!ref'] ? XLSX.utils.decode_range(worksheet['!ref'] || '').e.c : 0 } });
                        const jsonChunk = XLSX.utils.sheet_to_json(worksheet, { header: 1, range });
                        // process jsonChunk here (append to state or send to server)
                        console.log(jsonChunk)
                        allData = jsonChunk
                        setAllData(allData)
                    }

                    console.log(fileHeader)
                    console.log(korrectMapping)
                    DefaultCondition();
                }
            };
            reader.readAsArrayBuffer(file);
        } else {
            alert("Unsupported file type. Please upload a CSV or Excel file.");
        }
    };

    const DefaultCondition = () => {
        console.log(fileHeader)
        console.log(conditionList)

        var numeric_header = ['knett_c', 'kQuantity', 'kQuantity1', 'kQuantity2', 'kgross', 'DistFeePerc', 'kunitprice_c']

        if (fileHeader.length > 0) {
            conditionList = ''
            setConditionList(conditionList)

            for (var i = 0; i < numeric_header.length; i++) {
                const index = fileHeader.indexOf(numeric_header[i]);

                if (index !== -1) {
                    var con_val = 'F' + index + ' = ISNULL([dbo].[ConvertToNumeric]([F' + index + ']), 0)';
                    console.log(con_val)

                    if (conditionList.length > 0) {
                        conditionList = conditionList + ','
                    }
                    conditionList = conditionList + con_val;
                    setConditionList(conditionList)
                }
            }

            //conditionClearUp();
        }
    };

    const conditionClearUp = () => {

        const lines = fileHeader
            ?.split(/\r?\n/)
            ?.map((line: any) => line.trim().replace(/,+$/, ""))
            ?.filter((line: any) => line.length > 0);

        const seen = new Set<string>();
        const uniqueLines = [];

        for (const line of lines) {
            const normalized = line.toLowerCase();
            if (!seen.has(normalized)) {
                seen.add(normalized);
                uniqueLines.push(line);
            }
        }

        const formatted = uniqueLines
            .map((line, i) => (i < uniqueLines.length - 1 ? line + "," : line))
            .join("\n");

        setfileHeader(formatted);

        console.log(fileHeader)
    };

    const selectViewName = (e: any) => {

        var obj = tablesListing?.filter((item) => { return item.tableName === e })[0];
        console.log(e)
        console.log(obj)
        ViewName = obj;
        setViewNamee(ViewName)
        ViewCode = obj?.kontactCode;
        setViewCode(ViewCode)

        if (obj && obj) {
            var payload = {
                templateName: obj.tableName,
                templateSchema: obj.tableSchema,
                type: "templateHeader"
            }
            templateServices.genericAPIListing(payload).then((value: any) => {
                var obj = (CommonUtilities.relativeDataRemapping(value.data, value.headers.original));
                tableColumn = obj
                setTableColumn(tableColumn)
                console.log(tableColumn)
            })
        }

        console.log(ViewName)
        console.log(ViewName.kontactCode === "")
        console.log(ViewCode.length)
    };

    const updateMapping = (value: any, index: any) => {
        console.log(value)
        console.log(index)

        korrectMapping[index] = value;

        setkorrectMapping(korrectMapping)
        setkorrectMapping([...korrectMapping])

    };

    const columntaken = (e: any) => {

        if (korrectMapping && korrectMapping?.length > 0) {

            if (korrectMapping.length === fileHeader.length) {
                return true;
            } else {

                var obj = korrectMapping?.filter((item: any) => { return item === e })[0];
                console.log(obj)
                if (obj && obj.length > 0) {
                    return true;
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
    };

    const assignMapping = (e: any) => {

        console.log(e)

        const findIng = korrectMapping.filter((values: any) => values === e)
        console.log(findIng)
        console.log(findIng.length)

        if (findIng.length === 0) {

            const tempArray: [string] = korrectMapping;
            tempArray.push(e.toString());
            korrectMapping = tempArray
            setkorrectMapping(korrectMapping)
            setkorrectMapping([...korrectMapping])
        }
    };

    const ExportTemplate = (e: any) => {

        console.log(fileHeader);
        if (e === "BuildMapping") {
            console.log(korrectMapping);
            console.log(fileHeader);
            CommonUtilities.exportToCSVNoHeader(fileHeader, korrectMapping, 'Template_mapping.csv');
        }

        if (e === "BuildMappingData") {
            console.log(korrectMapping);
            console.log(fileHeader);
            console.log(allData);

            const data = [
                { name: 'Alice', age: 25, email: 'alice@example.com' },
                { name: 'Bob', age: 30 },
                { name: 'Charlie', age: 28, email: 'charlie@example.com', city: 'New York' },
            ];
            //CommonUtilities.exportToCSV(data, 'Template_mapping.csv')
            //CommonUtilities.exportToCSVNoHeader(fileHeader, allData, 'Template_mapping.csv');

            CommonUtilities.exportToCSV_Header(fileHeader, korrectMapping, allData, 'Template_mapping.csv');
            //CommonUtilities.exportToCSVNoHeader(fileHeader, korrectMapping, 'Template_mapping.csv');
        }

    };

    const removeUpload = () => {

        fileHeader = []
        setfileHeader(fileHeader)

        conditionList = ''
        setConditionList(conditionList)

        tableColumn = []
        setTableColumn(tableColumn)

        conditionValue = ''
        setConditionValue(conditionValue)

        conditionHeader = ''
        setConditionHeader(conditionHeader)

        korrectMapping = []
        setkorrectMapping(korrectMapping)

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }

        ViewName = []
        setViewNamee(ViewName)

        kontactCode = ''
        setKontactCode(kontactCode)

        console.log(fileHeader)
    };

    const addCondition = () => {

        console.log(conditionHeader)
        console.log(conditionValue)
        console.log(fileHeader)

        const index = fileHeader.indexOf(conditionHeader);
        if (conditionValue === "Numeric") {
            if (conditionList.length > 0) {
                conditionList = conditionList + ','
            }

            conditionList += ' F' + index + 1 + ' =  ISNULL([dbo].[ConvertToNumeric]([F' + index + 1 + ']), 0)';
        }

        if (conditionValue === "EscapeSpecificCharacter") {
            if (conditionList.length > 0) {
                conditionList = conditionList + ','
            }

            conditionList += ' F' + index + 1 + ' =  ISNULL([dbo].[EscapeSpecificCharacter]( ' + '""' + ',[F' + index + 1 + ']), 0)';
        }
        setConditionList(conditionList)
        console.log(conditionList)
    };

    const createTemplate = () => {

        let create_sts = true;

        var createPayload = {
            korrectMapping: korrectMapping ? korrectMapping.join(", ") : "",
            fileHeader: fileHeader ? fileHeader.join(", ") : "",
            conditionList: conditionList ? conditionList : "",
            kontactCode: kontactCode.length > 0 ? kontactCode : ViewName.kontactCode,
            tableName: ViewName.tableName ? ViewName.tableName : "",
            tableSchema: ViewName.tableSchema ? ViewName.tableSchema : "",
        }

        if (fileHeader.length === 0 || korrectMapping.length === 0) {
            CommonUtilities.showToast("Please Import a mapping");
            create_sts = false;
        }
        console.log(create_sts)

        if (korrectMapping.length > 0) {
            const hasDuplicates = korrectMapping.length !== new Set(korrectMapping).size;

            console.log(hasDuplicates)
            if (hasDuplicates) {
                CommonUtilities.showToast("Duplicate mapping exist")
                create_sts = false;
            }
        }
        console.log(create_sts)
        if (createPayload.kontactCode.length === 0 || createPayload.tableName.length === 0 || createPayload.tableSchema.length === 0) {
            CommonUtilities.showToast("Ensure View Name selected");
            create_sts = false;
        }

        console.log(create_sts)
        if (create_sts) {
            templateServices.createTemplate(createPayload).then((values: any) => {
                CommonUtilities.showToastSuccess("Template Created");
            })
        }

        console.log(korrectMapping)
        console.log(fileHeader)
        console.log(conditionList)
        console.log(kontactCode)
        console.log(ViewName)
        console.log(createPayload)
    };

    return (
        <>
            <div className="ws-12 pm mb">

                <div className="ws-12 box pm">

                    {<div className="ws-12 pm">
                        <span className="text-bold ws-2">View Name: </span>
                        <select className="ws-4" onChange={(e: any) => selectViewName(e.target.value)} value={ViewName && ViewName.tableName ? ViewName.tableName : ''}>
                            <option value="">-- Select View Name --</option>
                            {
                                tablesListing?.map((valse: any) => {
                                    return <option key={valse?.tableName} value={valse?.tableName}> {valse?.tableName} </option>
                                })
                            }
                        </select>
                    </div>}

                    {(ViewName && ViewName?.kontactCode === "") && <div className="ws-12 pm">
                        <span className="text-bold ws-2">DSP Name: </span>
                        <select className="ws-4" value={kontactCode ? kontactCode : ""} onChange={(e: any) => setKontactCode(e.target.value)}>
                            <option value="">-- Select DSP Name --</option>
                            {
                                ClientDSPList?.map((valse: any) => {
                                    return <option key={valse?.name} value={valse?.name}> {valse?.name} </option>

                                })
                            }
                        </select>
                    </div>}

                    {(ViewName && ViewName?.kontactCode !== "") && <div className="ws-12 pm">
                        <span className="text-bold ws-2">Name: </span>
                        <input  readOnly={true} value={ViewName?.kontactCode ? ViewName?.kontactCode : ""} />
                    </div>}

                    <div className="ws-12 pm">
                        <p className="text-bold ws-2">Import File/Mapping</p>
                        <input className="ws-4" type="file" accept=".csv, .xls, .xlsx" ref={fileInputRef} onChange={upLoadFile} />
                        <button className="btn-sm icon-btn edit pull-left mll" onClick={() => removeUpload()}> <i className="icon-refresh"></i> </button>
                    </div>

                </div>

                <div className="ws-12 mtl prl">

                    <div className="ws-7">

                        <div className={fileHeader && fileHeader.length > 0 ? "ws-12 allowVscroll full-height-vhmM" : "ws-12 allowVscroll"}>

                            <div className="ws-6">
                                <div className="pm box">
                                    <h1 className="mb">File Header</h1>
                                    {
                                        fileHeader?.map((entrieObj: any) => {
                                            return <input className="pm ws-12 mb" value={entrieObj} readOnly />
                                        })
                                    }
                                </div>
                            </div>

                            {<div className="ws-6 pl">

                                <div className="box pm mr">
                                    <h1 className="mb">Korrect Mapping</h1>
                                    {
                                        korrectMapping?.map((entrieObj: any, index: any) => {

                                            if (tableColumn?.length > 0) {

                                                return (
                                                    <>
                                                        <select onChange={(e: any) => updateMapping(e.target.value, index)} value={entrieObj} className="ws-12 ps mb">
                                                            <option value="">-- Select column Name--</option>
                                                            {
                                                                tableColumn?.map((valse: any) => {
                                                                    return (<option key={valse?.cOLUMN_NAME} value={valse?.cOLUMN_NAME}> {valse?.cOLUMN_NAME} </option>)
                                                                })

                                                            }
                                                        </select>
                                                    </>
                                                )

                                            } else {
                                                return <input className="pm ws-12 mb" value={entrieObj} />
                                            }

                                        })
                                    }
                                </div>

                            </div>}
                        </div>

                    </div>

                    <div className="ws-5">

                        <div className="box pm mll mr">
                            <h1 className="mb">
                                Table Column
                                <input type="text" placeholder="Search" className="mll" value={search} onChange={(e) => { setSearch(e.target.value) }}></input>
                            </h1>

                            {(tableColumn && tableColumn.length > 0) && <div className="allowHscroll allowVscroll full-height-vhmM">
                                {
                                    tableColumn.filter((vales: any) => search.length === 0 || vales.cOLUMN_NAME.toLowerCase().includes(search.toLowerCase()))?.map((entrieObj: any) => {
                                        return (
                                            <div className="ws-12">
                                                <button className="btn-m icon-btn edit btn-small mt" disabled={columntaken(entrieObj.cOLUMN_NAME)} onClick={() => assignMapping(entrieObj.cOLUMN_NAME)}>
                                                    <i className="icon-arrow-left"></i>
                                                </button>

                                                <div className="ps ws-5 pl">
                                                    <input className="ws-12" value={entrieObj.cOLUMN_NAME} readOnly />
                                                </div>

                                                <div className="ps ws-5 pl">
                                                    <input className="ws-12" value={entrieObj.dATA_TYPE} readOnly />
                                                </div>

                                            </div>
                                        )
                                    })
                                }
                            </div>}
                        </div>

                    </div>

                </div>

                {(fileHeader && fileHeader.length !== 0) && <div className="ws-12 mtl prl">
                    <div className="ws-12 box pm">
                        <h1 className="mb">Field Condition</h1>
                        <hr />
                        <div className="ws-7 pull-left">

                            <textarea className="ws-9" placeholder="Condition insert"
                                value={conditionList}
                                style={{ width: "95% !important", maxWidth: "99% !important" }}
                                onChange={(e: any) => setConditionList(e.target.value)}>

                            </textarea>
                        </div>

                        <div className="ws-5 pull-right box">

                            <h2 className="mb ws-12">File Header</h2>
                            <select value={conditionHeader} className="ws-12 ps mb" onChange={(e: any) => setConditionHeader(e.target.value)}>
                                <option value="">-- Select File Header --</option>
                                {
                                    fileHeader?.map((valse: any) => {
                                        return (<option key={valse} value={valse}> {valse} </option>)
                                    })
                                }
                            </select>

                            <h2 className="mb ws-12">File Condition</h2>
                            <select value={conditionValue} className="ws-12 ps mb" onChange={(e: any) => setConditionValue(e.target.value)}>
                                <option value="">-- Select File Condition --</option>
                                {
                                    conditionType?.map((valse: any) => {
                                        return (<option key={valse.conditionType} value={valse.conditionTypealse}> {valse.conditionType} </option>)
                                    })
                                }
                            </select>

                            <div className="ws-12">

                                <div className="ws-7 pull-left"></div>
                                <button className="icon-btn edit pull-right" onClick={() => addCondition()}       >Add Condition      </button>

                                <div className="mrl pull-left">
                                    <button className="icon-btn edit pull-right" onClick={() => DefaultCondition()}   > Reset Condition   </button>
                                    <button className="icon-btn edit pull-right" onClick={() => DefaultCondition()}   > Default Condition </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>}
            </div>

            <div className="ws-12 box pm">
                <button className="icon-btn edit pull-right" onClick={() => createTemplate()}> Create Template  </button>

                <div className="ws-2 pull-right">
                    <div className="verticalMediumWide hover-box text-center">

                        <ul className="hover-block textboxDropdownList rightReset">
                            <button className="icon-btn info ws-2 pull-right" onClick={() => ExportTemplate("BuildMapping")}> Export Build Template  </button>
                            <button className="icon-btn info ws-2 pull-right" onClick={() => ExportTemplate("BuildMappingData")}> Export Build Template with data  </button>
                        </ul>

                        <button type="button" className="icon-btn info btn pull-right">
                            Export Template
                        </button>
                    </div>
                </div>

            </div>

            <>
                {(() => {

                    if (uploadJob) {
                        return <TemplateOption param={true} message={"ingest template"} onChange={onStateUpload} />
                    }

                })()}
            </>
        </>
    )
}